import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const EventSubscriptionsServiceContext = createContext(undefined)

const EventSubscriptionsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={EventSubscriptionsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/events/event_subscriptions${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        updateBatch: async (payload) => {
          const {data} = await axios.patch(`/api/v1/events/event_subscriptions`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

EventSubscriptionsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useEventSubscriptionsService = () => {
  const context = useContext(EventSubscriptionsServiceContext)
  if (context === undefined) {
    throw new Error('EventSubscriptionsServiceContext was not provided. Make sure your component is a child of the EventSubscriptionsServiceProvider.')
  }
  return context
}

const useEventSubscriptionsQuery = ({query, ...otherProps}) => {
  const eventSubscriptionsService = useEventSubscriptionsService()
  return useSimpleQuery({
    queryKey: `event_subscriptions-list-${JSON.stringify(query)}`,
    queryFn: async () => eventSubscriptionsService.list(query),
    ...otherProps
  })
}

export {EventSubscriptionsServiceProvider, useEventSubscriptionsService, useEventSubscriptionsQuery}
